<template lang="pug"> 
  v-btn( 
    :disabled='loading || disabled'
    :loading='loading'
    :color="color"
    :block="block" 
    :rounded="rounded"
    :icon="icon"
    :large="large"
    depressed 
    outlined
    @click='$emit("click")'
  ) 
    slot

</template>
<script>
import ButtonMixin from '@/mixins/Button'
export default {
  mixins : [ButtonMixin], 
}
</script>